import Vue from 'vue'
import App from './App.vue'
import router from './router'

import fontSize from './utils/fontSize'
Vue.prototype.$fontSize = fontSize

// 按需引入echarts
import echarts from './utils/echarts'
Vue.prototype.$echarts = echarts

import axios from './utils/axios'
Vue.prototype.$http = axios
axios.defaults.baseURL = "https://www.bjdzhl.com"

import Bus from '../src/utils/bus'
Vue.prototype.$bus = Bus 

// 按需部分引入ElementUI部分组件
import 'element-ui/lib/theme-chalk/index.css'//element-ui的css
import {Button, Input, Carousel, CarouselItem, Image, Divider, Table, TableColumn, Popover, Dialog, Form, FormItem, Notification, Descriptions, DescriptionsItem, Radio} from 'element-ui' //element-ui的部分组件
Vue.use(Button);
Vue.use(Input);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Image);
Vue.use(Divider);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Radio);


Vue.prototype.Notification = Notification;


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
